import { render, staticRenderFns } from "./RouterPage.vue?vue&type=template&id=fcd01f52"
import script from "./RouterPage.vue?vue&type=script&lang=ts"
export * from "./RouterPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports